module.exports = __webpack_public_path__ + "static/media/scrum.833b386e.svg";